/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';

export const languageSchema = z.object({
  createdAt: z.string().datetime().nullish(),
  id: z.string().uuid(),
  name: z.string().nullish(),
  updatedAt: z.string().datetime().nullish(),
});

export type Language = z.infer<typeof languageSchema>;
